export function Energy(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0C2.68629 0 0 2.68629 0 6V18C0 21.3137 2.68629 24 6 24H18C21.3137 24 24 21.3137 24 18V6C24 2.68629 21.3137 0 18 0H6ZM9.98438 17.6641C8.98438 17.6641 8.38281 17.0703 8.38281 16.0547V8.60938C8.38281 7.60156 8.98438 7 9.98438 7H14.9453C15.6094 7 16.0859 7.5 16.0859 8.20312C16.0859 8.89844 15.6094 9.39062 14.9453 9.39062H11.4375V11.2422H14.7969C15.4062 11.2422 15.8203 11.6875 15.8203 12.3359C15.8203 12.9844 15.4062 13.4141 14.7969 13.4141H11.4375V15.2734H14.8984C15.6094 15.2734 16.0859 15.75 16.0859 16.4688C16.0859 17.1953 15.6094 17.6641 14.8906 17.6641H9.98438Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
